$(document).ready(function () {
  $(".as-field--counter input, .as-field--counter textarea").on(
    "input",
    function (e) {
      $(this)
        .parent()
        .find(".as-field__counter span")
        .text(e.target.value.length);
    }
  );
  // $(".as-button").each(function () {

  $(document).on("mouseenter", ".as-button", function () {
    const $btn = $(this);
    const $text = $btn.find(".as-button__text");
    const $icon = $btn.find(".as-button__icon");

    gsap.set([$text, $icon], { x: 0 });
    gsap.set($icon, { rotation: 0 });

    const btnWidth = $btn.outerWidth();
    const textWidth = $text.outerWidth();
    const iconWidth = $icon.outerWidth();

    const textX = -(btnWidth / 2 - 32 - textWidth / 2);
    const iconX = btnWidth / 2 - 16 - textWidth / 2 - iconWidth / 2;

    gsap.to($text, { x: textX, duration: 0.3, ease: "power2.out" });
    gsap.to($icon, {
      x: iconX,
      rotation: -30,
      duration: 0.3,
      ease: "power2.out",
    });
  });

  $(document).on("mouseleave", ".as-button", function () {
    const $btn = $(this);
    const $text = $btn.find(".as-button__text");
    const $icon = $btn.find(".as-button__icon");

    gsap.to($text, { x: 0, duration: 0.3, ease: "power2.out" });
    gsap.to($icon, { x: 0, rotation: 0, duration: 0.3, ease: "power2.out" });
  });
  // });
});
